import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Section from "./pages/Section";
import Search from "./pages/Search";
import FareCalculator from "./pages/FareCalculator";
import MileageChart from "./pages/MileageChart";
import Emergency from "./pages/Emergency";
import Admin from "./pages/Admin";
import { fetchChatHistory } from "./lib/api";
import { lsSet } from "./lib/storage";

// Hydrate a shared chat thread from ?chat=<sid> on any device
function ChatThreadHydrator() {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const sid = params.get("chat");
        if (!sid) return;
        let cancelled = false;
        fetchChatHistory(sid)
            .then((history) => {
                if (cancelled || !Array.isArray(history)) return;
                const msgs = history.map((m, i) => ({
                    id: `${m.role[0]}-${m.timestamp || Date.now()}-${i}`,
                    role: m.role,
                    content: m.content,
                }));
                lsSet("bscc.chat.messages.v1", msgs);
                lsSet("bscc.chat.session.v1", sid);
            })
            .catch(() => {})
            .finally(() => {
                // strip ?chat= but keep other params
                params.delete("chat");
                const q = params.toString();
                navigate({ pathname: location.pathname, search: q ? `?${q}` : "" }, { replace: true });
            });
        return () => { cancelled = true; };
    }, [location.search, location.pathname, navigate]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ChatThreadHydrator />
                <Routes>
                    <Route path="/admin" element={<Admin />} />
                    <Route
                        path="*"
                        element={
                            <Layout>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/section/:id" element={<Section />} />
                                    <Route path="/search" element={<Search />} />
                                    <Route path="/fare" element={<FareCalculator />} />
                                    <Route path="/mileage" element={<MileageChart />} />
                                    <Route path="/emergency" element={<Emergency />} />
                                </Routes>
                            </Layout>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
